const upSellDisplay = function () {

    const displayVarietiesModal = function (data, dataListNameOrigin) {
        var $modal = $('#modal-add-to-cart-other-flavours');
        var $result = $($.parseHTML(data));
        var hasFlavourTile = $result.find('.item-addToCart').length > 0;
        if (hasFlavourTile) {
            $modal.removeClass('modal-add-to-cart-other-flavours--empty');
        } else {
            $modal.addClass('modal-add-to-cart-other-flavours--empty');
        }

        var $replaceSection = $modal.find('.replaceMePlease');
        if ($replaceSection.length > 0) {
            $replaceSection.html('');
        }
        $replaceSection.html(data);

        if (data !== '') {
            injectSVG();
            $replaceSection.scrollTop(0);
        }
        bindFlavoursModalActionExceptions();
        $('#modal-add-to-cart-other-flavours-trigger').click();
        pushOtherFlavoursProductsViewToDatalayer(dataListNameOrigin);
        UAEvents.defineDocument('.modal-add-to-cart-other-flavours .tile-product', false);
        productTileSlick();
    }

    const displayUpsellSlide = function (data, productTile, dataListNameOrigin, isPDP, isPLP) {

        let $upSellContainer = $("<div/>", {
            class: "product-upSell-container module-template"
        });
        let $parentContainer = productTile.closest('.layout--mini-template > div');
        let $isSlickActive = $parentContainer.find($('.slick-initialized'));

        if (isPDP) {
            displayUpSellPDP(data, $parentContainer, $upSellContainer);
        } else {
            if ($('.product-upSell-container.opening').length) {
                closeUpSellPanel();
            }
            $upSellContainer.addClass('slick-upSell');
            $upSellContainer.html(data);
            if(isPLP){
                displayUpSellPLP(productTile, $upSellContainer);
            } else {
                displayUpSellHome(productTile, $parentContainer, $upSellContainer);
            }
        }

        productTile.addClass('product-upSell-active');
        $upSellContainer.addClass('opening');
        manageUpSellOuterClick($isSlickActive);
        initUpSellSlick(productTile);
        closeOuterTileClick();

    }

    function initUpSellSlick (productTile) {
        productUpSellSlick();
        upSellPanelControl();
        setTimeout(() => {
            $([document.documentElement, document.body]).animate({
                scrollTop: productTile.offset().top - 130
            }, 300);
        }, 200);

    }

    // FOR PDP //
    function displayUpSellPDP (data, $parentContainer, $upSellContainer) {
        let $isSlickActive = $parentContainer.find($('.slick-initialized'));
        $parentContainer = $('.pdp--upsell-container');
        $('.btn--pdp--displayFlavours').prop('disabled', true);
        $parentContainer.empty();
        $upSellContainer.addClass('slick-pdp-upSell').html(data);
        $parentContainer.html($upSellContainer);

        manageUpSellOuterClick($isSlickActive);
        productUpSellSlick();
        upSellPanelControl();
    }

    // FOR PlP //
    function displayUpSellPLP (productTile, $upSellContainer) {

        function appendUpSellPLP (display){
            if (productTile.parent().hasClass("criteo-container__tiles")) {
                if (productTile.hasClass(display)){
                    nexBreakRow = productTile;
                } else {
                    nexBreakRow = productTile.parents(".criteo-container").nextAll("." + display).first();
                    if(!nexBreakRow.length){
                        nexBreakRow = productTile.parents(".criteo-container").nextAll().last();
                    }
                }
            } else {
                if (productTile.hasClass(display)){
                    nexBreakRow = productTile;
                } else {
                    nexBreakRow = productTile.nextAll("." + display).first();
                    if(!nexBreakRow.length){
                        nexBreakRow = productTile.nextAll().last();
                    }
                }
            }
        }

        let nexBreakRow
        const maxmobile = window.matchMedia("(max-width: 975px)");
        const maxtablet = window.matchMedia("(max-width: 1200px)");

        if (maxmobile.matches) {
            nexBreakRow = productTile;
        } else if (maxtablet.matches) {
            appendUpSellPLP ('tabletRow')
        } else {
            appendUpSellPLP ('desktopRow')
        }

        $($upSellContainer).insertAfter(nexBreakRow);
    }

    // FOR HOMEPAGE //
    function displayUpSellHome (productTile, $parentContainer, $upSellContainer) {
        let $parentContainerFractionHalf = productTile.closest('.grid__half');
        let $parentContainerFractionThird = productTile.closest('.grid_third');
        let $parentContainerFractionQuarter = productTile.closest('.grid_quarter');
        let $isParentSlickMultiSlide = $parentContainer.find($('.slick-dotted')).length;
        let $isParentSlickComponent = $parentContainer.find($('.pt__carousel-advert-tile')).length;
        let $isParentSlimTileCarousel = $parentContainer.find($('.tiles--carousel-container')).length;

        //DEPENDING ON GRID TYPE AND SCREEN SIZE APPEND CROSS SELL CORRECTLY
        if ($parentContainerFractionHalf.length && (Revealizr.isMobileSize || Revealizr.isSmallTabletSize)) {
            $($upSellContainer).insertAfter($parentContainerFractionHalf);
        } else if ($parentContainerFractionThird.length) {
            if (Revealizr.isMobileSize) {
                $($upSellContainer).insertAfter($parentContainerFractionThird);
            } else if (Revealizr.isSmallTabletSize) {
                let tileIndex = $parentContainerFractionThird.index();
                let $tileParent = $parentContainerFractionThird.parent();
                let tileSiblingsLength = $tileParent.children().length - 1;
                if (tileSiblingsLength == tileIndex) {
                    $($upSellContainer).insertAfter($parentContainer);
                } else {
                    let tileWidth = $parentContainerFractionThird.width();
                    let screenWidth = $(window).width();
                    let tileLeftOffset = $parentContainerFractionThird.offset().left;
                    if (tileWidth < (screenWidth / 2)) {
                        if (tileIndex == '0' || tileLeftOffset < (screenWidth / 2)) {
                            $($upSellContainer).insertAfter($parentContainerFractionThird.next());
                        } else if (tileLeftOffset > (screenWidth / 2)) {
                            $($upSellContainer).insertAfter($parentContainerFractionThird);
                        }
                    } else if (tileWidth > (screenWidth / 2)) {
                        $($upSellContainer).insertAfter($parentContainerFractionThird);
                    }
                }
            } else {
                $($upSellContainer).insertAfter($parentContainer);
            }
        } else if ($parentContainerFractionQuarter.length) {
            getProductTileIndex($parentContainerFractionQuarter);
            if (Revealizr.isMobileSize) {
                $($upSellContainer).insertAfter($parentContainerFractionQuarter);
            } else if (Revealizr.isSmallTabletSize) {
                let tileIndex = $parentContainerFractionQuarter.index();
                let $tileParent = $parentContainerFractionQuarter.parent();
                let tileSiblingsLength = $tileParent.children().length - 1;
                let $mixedTileWidth = $tileParent.find('.grid__half').length;
                if ($mixedTileWidth) {
                    let tileWidth = $parentContainerFractionQuarter.width();
                    let screenWidth = $(window).width();
                    let tileLeftOffset = $parentContainerFractionQuarter.offset().left;
                    let isNextTileOrderNegative = $parentContainerFractionQuarter.next().hasClass('order--minus');
                    if (tileWidth < (screenWidth / 2)) {
                        if (tileLeftOffset < (screenWidth / 2)) {
                            if (isNextTileOrderNegative) {
                                $($upSellContainer).insertAfter($parentContainerFractionQuarter.next().next());
                            } else {
                                $($upSellContainer).insertAfter($parentContainerFractionQuarter.next());
                            }
                        } else if (tileLeftOffset > (screenWidth / 2)) {
                            $($upSellContainer).insertAfter($parentContainerFractionQuarter);
                        }
                    } else if (tileWidth > (screenWidth / 2)) {
                        $($upSellContainer).insertAfter($parentContainerFractionQuarter);
                    }

                } else if (tileSiblingsLength == tileIndex) {
                    $($upSellContainer).insertAfter($parentContainer);
                } else {
                    if ((tileIndex + 1) % 2 == 0) {
                        $($upSellContainer).insertAfter($parentContainerFractionQuarter);
                    } else {
                        $($upSellContainer).insertAfter($parentContainerFractionQuarter.next());
                    }
                }
            } else {
                $($upSellContainer).insertAfter($parentContainer);
            }
        } else {
            $($upSellContainer).insertAfter($parentContainer);
        }

        if ($isParentSlimTileCarousel) {
            $upSellContainer.addClass('upSell-container-adjust-pos-a');
        } else if ($isParentSlickMultiSlide) {
            $upSellContainer.addClass('upSell-container-adjust-pos-b');
        } else if ($isParentSlickComponent) {
            $upSellContainer.addClass('upSell-container-adjust-pos-c');
        }
    }

    return {
        displayVarietiesModal: displayVarietiesModal,
        displayUpsellSlide: displayUpsellSlide
    }
}();


function getProductTileIndex(productTileGridParent) {
    let childIndex = productTileGridParent;
    return childIndex.index();
}

function closeUpSellPanel() {
    $('.product-upSell-active').removeClass('product-upSell-active');
    $('.product-upSell-container.opening').addClass('closing').removeClass('opening');
    $('.displayVarietiesActive').removeClass('displayVarietiesActive');
    let $otherVarietiesPDP = $('.btn--pdp--displayFlavours');
    if ($otherVarietiesPDP.length) {
        $otherVarietiesPDP.prop('disabled', false);
    }
    setTimeout(() => {
        $('.product-upSell-container.closing').remove();
    }, 400);
}

function upSellPanelControl() {
    $('.close-upSell-panel').on('click', function () {
        closeUpSellPanel();
    });
}

 function closeOuterTileClick() {
     $(document).on("click", function(event) {
         if ((!$(event.target).closest($('.product-upSell-container')).length) && (!$(event.target).closest($('.product-upSell-active')).length)) {
             closeUpSellPanel();
         }
     });
 }

let manageUpSellOuterClick = function (parentSlick) {
    parentSlick.on('afterChange', function () {
        closeUpSellPanel();
        return;
    });
}

function pushOtherFlavoursProductsViewToDatalayer(dataListName) {
    if (typeof dataListName !== 'undefined') {
        var $modal = $('#modal-add-to-cart-other-flavours');
        $modal.find('.productsSlider').attr('data-list-name', dataListName);
        push_product_list_metrics($modal);
    }
}



document.addEventListener("DOMContentLoaded", function() {
    const produtsTile = document.querySelectorAll('.products-search--grid > .default-product-tile');
    const butterflyTile = document.querySelectorAll('.criteo-container');
    const numberProductDesktop = 5
    const numberProductTablet = 3
    const isPLP = document.querySelectorAll('.products-search--grid').length;


    function addClassLastProductInRow(numberProductInRow, valueOfbuterfly, classNameToAppend) {
        for (let i = 0; i < produtsTile.length; i++) {
            if (i % numberProductInRow === 0) {
                if(produtsTile[i+numberProductInRow-valueOfbuterfly]){
                    produtsTile[i+numberProductInRow-valueOfbuterfly].classList.add(classNameToAppend);
                }
            }
        }
    }

    if(isPLP){
        if(butterflyTile.length){
            addClassLastProductInRow(numberProductDesktop, 3, 'desktopRow');
            addClassLastProductInRow(numberProductTablet, 2, 'tabletRow');
        } else {
            addClassLastProductInRow(numberProductDesktop, 1, 'desktopRow');
            addClassLastProductInRow(numberProductTablet, 1, 'tabletRow');
        }
    }


});



const onResizeDebouncedUpSell = _.debounce(() => {
    if ($('.product-upSell-container.opening').length) {
        const windowWidth = window.innerWidth;
        const maxmobilewindow = 975;
        const maxtabletwindow = 1200;
        let inTablet = windowWidth >= maxmobilewindow && windowWidth <= maxtabletwindow;


        if (inTablet) {
            closeUpSellPanel();
        }
    }
}, 100);

window.addEventListener("resize", onResizeDebouncedUpSell);